const env = {};
const PROD = true;
const URL = PROD ? "https://n8.autobet-th.com" : "http://localhost";
env.url = URL;
env.parseServerUrl = `${URL}:1337/parse`;
env.appId = "7e6bbb10-0fcf-4867-8cd9-3b1d1b8c1d54";
env.masterKey = "957cde05-72eb-4c76-9eab-4dc5ed26650c";
env.javascriptKey = "395c10a3-280f-4255-8a97-4160bba00e44";
env.lineURL = "https://lin.ee/EGWBm6T";
env.appName = "Natural8 Thailand";
env.version = "1.4.7";

env.provider = "N8";
env.primaryColor = "#CE1F6A";
env.secondnaryColor = "#CE1F6A";
env.headerColor = "#1d072e";

export default env;
